import React from "react";
import { motion } from "framer-motion";
import { Trae, Anthropic } from "@lobehub/icons";

const Sponsors = () => {
  {
    /*}
  
  const sponsors = [
    {
      name: "Anthropic",
      logo: "component",
      website: "https://anthropic.com",
      blurb:
        "AI safety and research company building reliable, interpretable, and steerable AI systems.",
    },
    {
      name: "Beta",
      logo: "/Beta.svg",
      website: "https://www.betauniversity.org",
      blurb:
        "Beta University's free 8-week Bay Area pre-acceleration program helps founders build VC-fundable businesses.",
    },
    {
      name: "MongoDB",
      logo: "/MongoDB.svg",
      website: "https://mongodb.com",
      blurb:
        "MongoDB, the world's most popular modern database, enables builders to streamline the development of their next-generation AI-powered applications.",
    },
    {
      name: "Neo4j",
      logo: "/Neo4j_Logo.svg",
      website: "https://neo4j.com",
      blurb:
        "Neo4j, the Graph Database & Analytics leader, helps organizations find hidden patterns and relationships across billions of data connections deeply, easily, and quickly.",
    },
    {
      name: "Replit",
      logo: "/Replit.svg",
      website: "https://replit.com",
      blurb:
        "Replit is the secure & agentic software creation platform that enables anyone to build applications using natural language. With millions of users worldwide, Replit is democratizing software development by removing traditional barriers to application creation.",
    },
    {
      name: "Snowflake",
      logo: "/Snowflake.svg",
      website: "https://snowflake.com",
      blurb:
        "Snowflake is the platform for the AI era, making it easy for enterprises to innovate faster and get more value from data.",
    },
    {
      name: "Trae",
      logo: "component",
      website: "https://trae.ai",
      blurb:
        "Trae is an AI-powered IDE that enhances developer productivity through intelligent code completion and automated assistance.",
    },
    {
      name: "Vectara",
      logo: "/Vectara.svg",
      website: "https://vectara.com",
      blurb:
        "Vectara is a developer-first platform for building GenAI applications with trusted, hallucination-free conversational search and retrieval augmented generation.",
    },
  ];
*/
  }

  const sponsors = [
    {
      name: "Anthropic",
      logo: "component",
      website: "https://anthropic.com",
      blurb:
        "AI safety and research company building reliable, interpretable, and steerable AI systems.",
    },
    {
      name: "MongoDB",
      logo: "/MongoDB.svg",
      website: "https://mongodb.com",
      blurb:
        "MongoDB, the world's most popular modern database, enables builders to streamline the development of their next-generation AI-powered applications.",
    },
    {
      name: "Neo4j",
      logo: "/Neo4j_Logo.svg",
      website: "https://neo4j.com",
      blurb:
        "Neo4j, the Graph Database & Analytics leader, helps organizations find hidden patterns and relationships across billions of data connections deeply, easily, and quickly.",
    },
    {
      name: "Qdrant",
      logo: "/Qdrant.svg",
      website: "https://qdrant.tech",
      blurb:
        "Qdrant is the leading open source vector database and similarity search engine designed to handle high-dimensional vectors for massive-scale AI applications.",
    },
    {
      name: "Replit",
      logo: "/Replit.svg",
      website: "https://replit.com",
      blurb:
        "Replit is the secure & agentic software creation platform used by millions worldwide that enables anyone to build applications using natural language.",
    },
    {
      name: "SAP",
      logo: "/SAP.svg",
      website: "https://sap.com",
      blurb:
        "SAP is the world's largest provider of enterprise application software, bringing out the best in every business with trusted Business AI.",
    },
    {
      name: "Snowflake",
      logo: "/Snowflake.svg",
      website: "https://snowflake.com",
      blurb:
        "Snowflake is the platform for the AI era, making it easy for enterprises to innovate faster and get more value from data.",
    },
    {
      name: "Trae",
      logo: "/Trae.svg",
      website: "https://trae.ai",
      blurb:
        "Trae is a leading AI Coding IDE that independently builds complete software solutions for you.",
    },
    {
      name: "Vectara",
      logo: "/Vectara.svg",
      website: "https://vectara.com",
      blurb:
        "Vectara is a developer-first platform for building GenAI applications with trusted, hallucination-free conversational search and retrieval augmented generation.",
    },
  ];

  const cohosts = [
    {
      name: "AI Fund",
      logo: "/AF_Logo_FC.svg",
      website: "https://aifund.ai",
      blurb:
        "AI Fund is a venture studio. We collaborate with entrepreneurs, venture funds, and corporate partners to create great companies that move humanity forward.",
    },
    {
      name: "DeepLearning",
      logo: "/Deep_Learning.svg",
      website: "https://deeplearning.ai",
      blurb:
        "DeepLearning.AI is making a world-class AI education accessible to people around the globe. DeepLearning.AI was founded by Andrew Ng, a global leader in AI.",
    },
  ];

  const partners = [];

  return (
    <div className="py-20 bg-gray-50 dark:bg-gray-800 transition-colors duration-300 dark:shadow-2xl dark:shadow-white/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Sponsors and Partners
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            We're grateful to work with amazing companies that are driving
            innovation in AI and technology.
          </p>
        </motion.div>

        {/* Sponsors Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-8 text-center">
            Sponsors
          </h3>
          <div
            className={`grid gap-8 max-w-6xl mx-auto ${
              sponsors.length === 1
                ? "grid-cols-1 place-items-center"
                : "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
            }`}
          >
            {sponsors.map((sponsor, index) => (
              <motion.div
                key={sponsor.name}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="group"
              >
                <motion.a
                  href={sponsor.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="block"
                >
                  <div
                    className={`bg-white dark:bg-gray-900 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 dark:border-gray-700 hover:border-aifund/30 dark:hover:border-aifund/50 h-72 max-[378px]:h-auto max-[378px]:min-h-[200px] flex flex-col ${
                      sponsor.name === "Snowflake"
                        ? "dark:[box-shadow:0_10px_25px_-3px_rgba(36,158,220,0.3),0_4px_6px_-2px_rgba(36,158,220,0.2)] dark:hover:[box-shadow:0_20px_40px_-4px_rgba(36,158,220,0.4),0_8px_16px_-4px_rgba(36,158,220,0.3)]"
                        : sponsor.name === "Trae"
                        ? "dark:[box-shadow:0_10px_25px_-3px_rgba(0,237,100,0.3),0_4px_6px_-2px_rgba(0,237,100,0.2)] dark:hover:[box-shadow:0_20px_40px_-4px_rgba(0,237,100,0.4),0_8px_16px_-4px_rgba(0,237,100,0.3)]"
                        : sponsor.name === "Neo4j"
                        ? "dark:[box-shadow:0_10px_25px_-3px_rgba(10,97,144,0.3),0_4px_6px_-2px_rgba(10,97,144,0.2)] dark:hover:[box-shadow:0_20px_40px_-4px_rgba(10,97,144,0.4),0_8px_16px_-4px_rgba(10,97,144,0.3)]"
                        : sponsor.name === "Qdrant"
                        ? "dark:[box-shadow:0_10px_25px_-3px_rgba(220,36,76,0.3),0_4px_6px_-2px_rgba(220,36,76,0.2)] dark:hover:[box-shadow:0_20px_40px_-4px_rgba(220,36,76,0.4),0_8px_16px_-4px_rgba(220,36,76,0.3)]"
                        : sponsor.name === "MongoDB"
                        ? "dark:[box-shadow:0_10px_25px_-3px_rgba(0,150,60,0.3),0_4px_6px_-2px_rgba(0,150,60,0.2)] dark:hover:[box-shadow:0_20px_40px_-4px_rgba(0,150,60,0.4),0_8px_16px_-4px_rgba(0,150,60,0.3)]"
                        : sponsor.name === "Anthropic"
                        ? "dark:[box-shadow:0_10px_25px_-3px_rgba(217,119,87,0.3),0_4px_6px_-2px_rgba(217,119,87,0.2)] dark:hover:[box-shadow:0_20px_40px_-4px_rgba(217,119,87,0.4),0_8px_16px_-4px_rgba(217,119,87,0.3)]"
                        : sponsor.name === "Beta"
                        ? "dark:[box-shadow:0_10px_25px_-3px_rgba(255,212,43,0.3),0_4px_6px_-2px_rgba(255,212,43,0.2)] dark:hover:[box-shadow:0_20px_40px_-4px_rgba(255,212,43,0.4),0_8px_16px_-4px_rgba(255,212,43,0.3)]"
                        : sponsor.name === "Replit"
                        ? "dark:[box-shadow:0_10px_25px_-3px_rgba(242,98,7,0.3),0_4px_6px_-2px_rgba(242,98,7,0.2)] dark:hover:[box-shadow:0_20px_40px_-4px_rgba(242,98,7,0.4),0_8px_16px_-4px_rgba(242,98,7,0.3)]"
                        : sponsor.name === "SAP"
                        ? "dark:[box-shadow:0_10px_25px_-3px_rgba(8,84,212,0.3),0_4px_6px_-2px_rgba(8,84,212,0.2)] dark:hover:[box-shadow:0_20px_40px_-4px_rgba(8,84,212,0.4),0_8px_16px_-4px_rgba(8,84,212,0.3)]"
                        : sponsor.name === "Vectara"
                        ? "dark:[box-shadow:0_10px_25px_-3px_rgba(124,58,237,0.3),0_4px_6px_-2px_rgba(124,58,237,0.2)] dark:hover:[box-shadow:0_20px_40px_-4px_rgba(124,58,237,0.4),0_8px_16px_-4px_rgba(124,58,237,0.3)]"
                        : "dark:shadow-white/10 dark:hover:shadow-white/20"
                    }`}
                  >
                    <div className="flex flex-col items-center text-center h-full">
                      <div className="flex-shrink-0 mb-4 h-32 w-full flex items-center justify-center">
                        {sponsor.name === "Anthropic" ? (
                          <div className="p-4 flex items-center justify-center overflow-hidden max-w-full max-h-full">
                            <div className="max-w-full max-h-full flex items-center justify-center">
                              <Anthropic.Text
                                size={56}
                                className="max-w-full max-h-full dark:filter dark:brightness-0 dark:invert"
                              />
                            </div>
                          </div>
                        ) : sponsor.name === "SAP" ? (
                          <div className="p-4 flex items-center justify-center overflow-hidden max-w-full max-h-full">
                            <div className="max-w-full max-h-full flex items-center justify-center relative">
                              {/* Light mode: Regular SAP logo */}
                              <div className="dark:hidden">
                                <img
                                  src="/SAP.svg"
                                  alt="SAP"
                                  className="h-14 w-auto object-contain mx-auto"
                                />
                              </div>
                              {/* Dark mode: White SAP logo */}
                              <div className="hidden dark:block">
                                <img
                                  src="/SAP_White.svg"
                                  alt="SAP"
                                  className="h-14 w-auto object-contain mx-auto"
                                />
                              </div>
                            </div>
                          </div>
                        ) : sponsor.name === "MongoDB" ||
                          sponsor.name === "Neo4j" ||
                          sponsor.name === "Qdrant" ||
                          sponsor.name === "Replit" ||
                          sponsor.name === "Trae" ||
                          sponsor.name === "Vectara" ? (
                          <div className="p-4">
                            <img
                              src={sponsor.logo}
                              alt={sponsor.name}
                              className="h-14 w-auto object-contain mx-auto dark:filter dark:brightness-0 dark:invert"
                            />
                          </div>
                        ) : (
                          <div className="p-4">
                            <img
                              src={sponsor.logo}
                              alt={sponsor.name}
                              className="h-14 w-auto object-contain mx-auto dark:filter dark:brightness-0 dark:invert"
                            />
                          </div>
                        )}
                      </div>
                      <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed flex-grow flex items-center">
                        {sponsor.blurb}
                      </p>
                    </div>
                  </div>
                </motion.a>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Partners Section */}
        {partners.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
            className="mb-12"
          >
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-8 text-center">
              Partners
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {partners.map((partner, index) => (
                <motion.div
                  key={partner.name}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="group"
                >
                  <motion.a
                    href={partner.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    className="block"
                  >
                    <div
                      className={`bg-white dark:bg-gray-900 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 dark:border-gray-700 hover:border-aifund/30 dark:hover:border-aifund/50 h-72 max-[378px]:h-auto max-[378px]:min-h-[200px] flex flex-col ${
                        partner.name === "Beta"
                          ? "dark:[box-shadow:0_10px_25px_-3px_rgba(255,212,43,0.3),0_4px_6px_-2px_rgba(255,212,43,0.2)] dark:hover:[box-shadow:0_20px_40px_-4px_rgba(255,212,43,0.4),0_8px_16px_-4px_rgba(255,212,43,0.3)]"
                          : "dark:shadow-white/10 dark:hover:shadow-white/20"
                      }`}
                    >
                      <div className="flex flex-col items-center text-center h-full">
                        <div className="flex-shrink-0 mb-4 h-32 w-full flex items-center justify-center">
                          <div className="p-4">
                            <img
                              src={partner.logo}
                              alt={partner.name}
                              className="h-14 w-auto object-contain mx-auto dark:filter dark:brightness-0 dark:invert"
                            />
                          </div>
                        </div>
                        <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed flex-grow flex items-center">
                          {partner.blurb}
                        </p>
                      </div>
                    </div>
                  </motion.a>
                </motion.div>
              ))}
            </div>
          </motion.div>
        )}

        {/* Co-hosts Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-8 text-center">
            Hosts
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {cohosts.map((cohost, index) => (
              <motion.div
                key={cohost.name}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="group"
              >
                <motion.a
                  href={cohost.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="block"
                >
                  <div
                    className={`bg-white dark:bg-gray-900 rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 dark:border-gray-700 hover:border-aifund/30 dark:hover:border-aifund/50 h-72 max-[378px]:h-auto max-[378px]:min-h-[200px] flex flex-col ${
                      cohost.name === "DeepLearning"
                        ? "dark:[box-shadow:0_10px_25px_-3px_rgba(246,91,102,0.3),0_4px_6px_-2px_rgba(246,91,102,0.2)] dark:hover:[box-shadow:0_20px_40px_-4px_rgba(246,91,102,0.4),0_8px_16px_-4px_rgba(246,91,102,0.3)]"
                        : cohost.name === "AI Fund"
                        ? "dark:[box-shadow:0_10px_25px_-3px_rgba(0,143,255,0.3),0_4px_6px_-2px_rgba(0,143,255,0.2)] dark:hover:[box-shadow:0_20px_40px_-4px_rgba(0,143,255,0.4),0_8px_16px_-4px_rgba(0,143,255,0.3)]"
                        : "dark:shadow-white/10 dark:hover:shadow-white/20"
                    }`}
                  >
                    <div className="flex flex-col items-center text-center h-full">
                      <div className="flex-shrink-0 mb-4 h-32 w-full flex items-center justify-center">
                        <div className="p-4">
                          <img
                            src={cohost.logo}
                            alt={cohost.name}
                            className="h-14 w-auto object-contain mx-auto dark:filter dark:brightness-0 dark:invert"
                          />
                        </div>
                      </div>
                      <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed flex-grow flex items-center">
                        {cohost.blurb}
                      </p>
                    </div>
                  </div>
                </motion.a>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Become a Sponsor CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="text-center mt-16 bg-aifund/5 dark:bg-aifund/10 rounded-2xl p-8 border border-aifund/20 dark:border-aifund/30 transition-colors duration-300 max-w-4xl mx-auto"
        >
          <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">
            Want to Become a Sponsor?
          </h3>
          <p className="text-lg mb-6 text-gray-700 dark:text-gray-300">
            Join our community of forward-thinking companies and help shape the
            future of AI.
          </p>
          <motion.a
            href="/sponsor-contact"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-aifund text-white px-8 py-3 rounded-full font-semibold hover:bg-aifund-dark transition-colors duration-200 shadow-lg hover:shadow-xl inline-block"
          >
            Contact Us
          </motion.a>
        </motion.div>
      </div>
    </div>
  );
};

export default Sponsors;
